(function () {
  var styleId = 'cfw-consent-position';
  var observed = new WeakSet();

  function attachStyle(host) {
    var root = host.shadowRoot;
    if (!root || root.getElementById(styleId)) return;
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      :host {
        position: static !important;
        inset: auto !important;
        display: block !important;
        box-sizing: border-box;
        width: 100%;
        padding: 16px 24px calc(16px + env(safe-area-inset-bottom, 0px));
        background: #F6F1E7;
      }
      button.widget {
        position: relative !important;
        inset: auto !important;
        transform: none !important;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        width: auto;
        max-width: 100%;
        height: auto;
        min-height: 44px;
        margin: 0;
        padding: 8px 12px;
        border-radius: 8px;
        box-shadow: none;
      }
      button.widget .img { flex-shrink: 0; }
      button.widget::after {
        content: attr(aria-label);
        font-size: 14px;
        line-height: 1.4;
      }
      @media (max-width: 749px) {
        :host { padding: 16px 14px calc(104px + env(safe-area-inset-bottom, 0px)); }
      }
    `;
    root.appendChild(style);
  }

  function locateWidget() {
    document.querySelectorAll('pandectes-cmp').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root || observed.has(host)) return;
      observed.add(host);
      if (root.querySelector('button.widget')) {
        attachStyle(host);
        return;
      }
      var widgetObserver = new MutationObserver(function () {
        if (root.querySelector('button.widget')) {
          attachStyle(host);
          widgetObserver.disconnect();
        }
      });
      widgetObserver.observe(root, { childList: true, subtree: true });
    });
  }

  if (!window.customElements) return;
  window.customElements.whenDefined('pandectes-cmp').then(function () {
    locateWidget();
    var hostObserver = new MutationObserver(locateWidget);
    hostObserver.observe(document.body, { childList: true });
  });
})();
